export const programs_user = {
  logo: "https://d2guulkeunn7d8.cloudfront.net/assets/footer/carrot-footer-v3-be31bf38601e4aab043b0f0071b50a024a7e53853a38371ade2822d5aa46875b.svg",
  slogan: "Get deliveries with Instacart",
  arr: [
    {
      title: "Top departments",
      body: [
        "Fresh Produce",
        "Dairy Products",
        "Meat",
        "Meat Alternatives",
        "Sea Food",
        "Pantry Food",
        "Baked Goods",
        "View all departments",
      ],
    },
    {
      title: "More departments",
      body: [
        "Alcohol",
        "Alcohol by Location ",
        "Frozen Food", 
        "Beverages", 
        "Organic Grocery", 
        "Household Essentials", 
        "Office Supplies", 
        "Beauty Products"
      ],
    },
    {
      title: "Instacart programs",
      body: [
        "Gift Cards",
        "EBT SNAP",
        "Promos & Coupons",
        "Gift Cards",
        "Grocery Budget Calculator",
        "Instacart Ads",
        "Instacart+",
        "Instacart Connect",
        "Careers"
      ],
    },
    {
      title: "Get to know us",
      body: [
        "Press",
        "Blog",
        "Ideas & Guides",
        "Contact",
        "Help",
        "Shop By Location"
      ],
    },
  ],
};
